// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wIfl4","title":"Info_title__GGPSB","selects":"Info_selects__2SU3a","requiredAsterisk":"Info_requiredAsterisk__1-SUL"};